import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Search } from 'lucide-react';

const CATEGORIES = [
  'Academia e Esporte', 'Beleza Feminina', 'Beleza Masculina', 'Estética e Bem-estar',
  'Moda e Acessórios', 'Infantil e RN', 'Saúde', 'Saúde Veterinária',
  'Pet Shop', 'Casa e Decoração', 'Construção e Reforma', 'Eletrônicos e Tecnologia',
  'Veículos Elétricos', 'Carro e Motos', 'Gastronomia e Bebidas', 'Manutenção e Reparos',
  'Lazer e Diversão', 'Educação e Ensino'
];

export function UserFilters({
  searchTerm, setSearchTerm,
  stateFilter, onStateChange,
  cityFilter, onCityChange,
  categoryFilter, setCategoryFilter,
  sortBy, setSortBy,
  states, cities
}) {
  return (
    <Card className="mb-6 hero-card">
      <CardHeader>
        <CardTitle>Buscar Cupons</CardTitle>
        <CardDescription className="text-slate-300">Filtre por categoria, cidade ou busca livre</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400" />
            <Input placeholder="Buscar cupons..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="pl-10" data-testid="search-input" />
          </div>
          <Select value={stateFilter || undefined} onValueChange={onStateChange}>
            <SelectTrigger data-testid="state-filter"><SelectValue placeholder="Todos os estados" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todos os estados</SelectItem>
              {states.map(s => (<SelectItem key={s} value={s}>{s}</SelectItem>))}
            </SelectContent>
          </Select>
          <Select value={cityFilter || undefined} onValueChange={onCityChange}>
            <SelectTrigger data-testid="city-filter"><SelectValue placeholder="Todas as cidades" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todas as cidades</SelectItem>
              {cities.map(city => (<SelectItem key={city} value={city}>{city}</SelectItem>))}
            </SelectContent>
          </Select>
          <Select value={categoryFilter || undefined} onValueChange={setCategoryFilter}>
            <SelectTrigger data-testid="category-filter"><SelectValue placeholder="Todas as categorias" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todas as categorias</SelectItem>
              {CATEGORIES.map(cat => (<SelectItem key={cat} value={cat}>{cat}</SelectItem>))}
            </SelectContent>
          </Select>
          <Select value={sortBy} onValueChange={setSortBy}>
            <SelectTrigger data-testid="sort-filter"><SelectValue placeholder="Ordenar por" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="newest">Mais Recente</SelectItem>
              <SelectItem value="highest_discount">Maior Desconto</SelectItem>
              <SelectItem value="lowest_discount">Menor Desconto</SelectItem>
              <SelectItem value="expiring_soon">Prazo que Expira</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
}
